import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import FormContact from './FormContact';
import '../Styles/contact.css';

export default class Contact extends Component {
  render() {
    const contactInfo = [
      {
        icon: "fas fa-map-marker-alt",
        title: "Visit Us",
        details: ["Kairaly Hotels & Holidays", "Pattanakkad, Cherthala, Alappuzha, Kerala", "India - 688531"],
        gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        color: "#667eea"
      },
      {
        icon: "fas fa-phone-alt",
        title: "Call Us",
        details: ["+91 9497660163", "+91 9037675072", "+91 9995600670", "24/7 Customer Support"],
        gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        color: "#f5576c"
      },
      {
        icon: "far fa-envelope",
        title: "Email Us",
        details: ["kairalyhotels@gmail.com", "kairalyholidays@gmail.com", "We reply within 24 hours"],
        gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
        color: "#4facfe"
      },
      {
        icon: "far fa-clock",
        title: "Working Hours",
        details: ["24/7 - Full Time", "24/7 Emergency Support", "You can contact us anytime!"],
        gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
        color: "#43e97b"
      }
    ];

    const features = [
      {
        icon: "fas fa-headset",
        title: "24/7 Support",
        description: "Round the clock customer support for your travel needs",
        color: "#ff6b35"
      },
      {
        icon: "fas fa-clock",
        title: "Quick Response",
        description: "We respond to all inquiries within 24 hours",
        color: "#4facfe"
      },
      {
        icon: "fas fa-smile",
        title: "Expert Advice",
        description: "Professional travel consultants with local expertise",
        color: "#43e97b"
      },
      {
        icon: "fas fa-shield-alt",
        title: "Secure Booking",
        description: "Safe and secure payment methods",
        color: "#f5576c"
      }
    ];

    return (
      <div className="contact-page">
        {/* Animated Background */}
        <div className="animated-bg">
          <div className="gradient-bg"></div>
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
          </div>
        </div>

        {/* Hero Section */}
        <div className="contact-hero">
          <div className="contact-hero-overlay"></div>
          <div className="contact-hero-content">
            <div className="hero-animation">
              <div className="pulse-ring"></div>
              <div className="pulse-ring delay-1"></div>
              <div className="pulse-ring delay-2"></div>
            </div>
            <h1 className="contact-hero-title">
              <span className="title-word">Let's</span>
              <span className="title-word gradient-text">Connect</span>
            </h1>
            <p className="contact-hero-subtitle">
              We're here to help you plan your perfect journey
            </p>
            <div className="contact-hero-badge">
              <i className="fas fa-headset"></i>
              <span>24/7 Customer Support</span>
            </div>
          </div>
          {/* <div className="hero-wave">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,165.3C1248,149,1344,107,1392,85.3L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div> */}
        </div>

        {/* Contact Information Section */}
        <div className="contact-info-section">
          <div className="section-header">
            <h2 className="section-title-animated">Get in Touch</h2>
            <p className="section-subtitle-animated">We'd love to hear from you</p>
          </div>
          <Grid>
            <Row className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="info-col">
                  <div className="info-card" style={{ background: info.gradient }}>
                    <div className="info-icon">
                      <i className={info.icon}></i>
                    </div>
                    <h3 className="info-title">{info.title}</h3>
                    {info.details.map((detail, idx) => (
                      <p key={idx} className="info-detail">{detail}</p>
                    ))}
                    <div className="card-shine"></div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Main Contact Section */}
        <div className="contact-main-section">
          <Grid>
            <Row>
              <Col xs={12} md={5} className="contact-left">
                <div className="contact-description">
                  <div className="section-badge">
                    <span>Why Choose Us</span>
                  </div>
                  <h2 className="contact-section-title">We're Here to Help You</h2>
                  <p className="description-text">
                    At Kairaly Hotels & Holidays, we want to make sure that your trip is everything 
                    you could possibly dream of. Whether you want inspiration and guidance in planning 
                    your next adventure or need help with an existing booking, our travel experts are 
                    here to help.
                  </p>
                  <p className="description-text">
                    Send us an email or give our team a call to book your flights, plan your adventure, 
                    or get help with any problems you encounter along the way.
                  </p>
                  
                  <div className="features-list">
                    {features.map((feature, index) => (
                      <div key={index} className="feature-item" style={{ borderLeftColor: feature.color }}>
                        <div className="contact-feature-icon" style={{ background: `${feature.color}20` }}>
                          <i className={feature.icon} style={{ color: feature.color }}></i>
                        </div>
                        <div className="feature-content">
                          <h4>{feature.title}</h4>
                          <p>{feature.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="social-connect">
                    <h4>Connect with us</h4>
                    <div className="social-links">
                      <a href="#" className="social-link fb"><i className="fab fa-facebook-f"></i></a>
                      <a href="#" className="social-link ig"><i className="fab fa-instagram"></i></a>
                      <a href="#" className="social-link wa"><i className="fab fa-whatsapp"></i></a>
                      <a href="#" className="social-link tw"><i className="fab fa-twitter"></i></a>
                    </div>
                  </div>
                </div>
              </Col>
              
              <Col xs={12} md={7} className="contact-right">
                <div className="contact-form-wrapper">
                  <div className="form-header">
                    <div className="form-icon">
                      <i className="fas fa-paper-plane"></i>
                    </div>
                    <h3>Send Us a Message</h3>
                    <p>We'll get back to you as soon as possible</p>
                  </div>
                  <FormContact />
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Map Section with Enhanced Design */}
        <div className="contact-map-section">
          <div className="map-title">
            <h3>Find Us Here</h3>
            <p>Visit our office in the heart of Alappuzha</p>
          </div>
          <div className="map-container">
            <iframe
              title="Kairaly Holidays Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4823.23953470935!2d76.31505297586054!3d9.738710490353728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b087b0fce30d373%3A0x9c9000cacd0320fd!2sKairaly%20Hotels%20%26%20Holidays!5e1!3m2!1sen!2sin!4v1775791790315!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="map-overlay">
              <div className="map-card">
                <div className="map-pulse"></div>
                <i className="fas fa-map-marker-alt"></i>
                <h4>Visit Our Office</h4>
                <p>Kairaly Hotels & Holidays, Alappuzha, Kerala</p>
                <div className="direction-btn">
                  <span>Get Directions</span>
                  <i className="fas fa-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}